<template>
	<div class="message">
		<div class="message-wrap">
			<div class="message-wrap2">
				<div
					class="white-wrap"
					:style="{
						height: myHeight,
						width: myWidth,
						overflow: overflow,
						'background-color': bg,
					}"
				>
					<slot name="content"></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		myHeight: String,
		myWidth: String,
		bg: String,
		overflow: {
			type: String,
			default: "hidden",
		},
	},
	methods: {},
};
</script>

<style scoped lang="less">
.message {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 9;
	width: 100%;
	height: 100%;
	background-color: rgba(81, 81, 81, 0.35);

	.message-wrap {
		width: 100%;
		height: 100%;
		padding-top: 1px;
		box-sizing: border-box;

		.message-wrap2 {
			position: relative;
			width: 100%;
			height: 540px;
			margin-top: 53px;
		}
	}
	.white-wrap {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		width: 490px;
		height: 265px;
		border-radius: 7px;
		box-sizing: border-box;
		box-shadow: 0px 0px 5px 2px rgba(193, 193, 193, 0.5);
		overflow: hidden;
	}
}
</style>
